module.exports = __webpack_public_path__ + "static/media/icon_rlb.08473ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_rlb.png
// module id = 1624
// module chunks = 0